import { LocalizedLink as Link } from '../../../components/LocalizedLink';
import { useTranslation } from 'react-i18next';

interface FooterProps {
  withCTA?: boolean;
}

const Footer = ({ withCTA = true }: FooterProps) => {
  const { t } = useTranslation();
  return (
    <footer className="bg-white text-gray-900 py-12 md:py-20 px-2 md:px-10 border-t border-gray-100">
      <div className="max-w-7xl mx-auto">
        {withCTA && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-20 mb-12 md:mb-20">
            <div>
              <h2 className="font-display text-4xl md:text-8xl font-bold uppercase tracking-tighter mb-12">
                {t('footer.cta.title')}<br />
                <span className="text-gray-400 italic">{t('footer.cta.highlight')}</span>
              </h2>
              <Link 
                to="/contact" 
                className="inline-flex items-center gap-4 group"
              >
                <span className="font-display text-2xl uppercase tracking-tight border-b border-gray-900 pb-2 group-hover:text-gray-400 group-hover:border-gray-400 transition-all">
                  {t('footer.cta.button')}
                </span>
                <div className="w-12 h-12 rounded-full border border-gray-900 flex items-center justify-center group-hover:bg-gray-900 group-hover:text-white transition-all">
                  <i className="ri-arrow-right-line text-2xl"></i>
                </div>
              </Link>
            </div>
            
            <div className="flex flex-col justify-end items-start md:items-end">
              <div className="space-y-4 text-left md:text-right">
                <p className="font-display text-[10px] tracking-[0.3em] text-gray-400 uppercase mb-4">{t('footer.social.title')}</p>
                <div className="flex flex-col gap-2">
                  <a href="https://instagram.com/mood_agency" target="_blank" className="font-display text-2xl uppercase tracking-tight hover:italic transition-all">Instagram</a>
                  <a href="https://linkedin.com/company/mood-digital-agency" target="_blank" className="font-display text-2xl uppercase tracking-tight hover:italic transition-all">LinkedIn</a>
                  <a href="https://twitter.com/mood_agency" target="_blank" className="font-display text-2xl uppercase tracking-tight hover:italic transition-all">Twitter</a>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center pt-12 border-t border-gray-100 gap-8">
          <div className="flex items-center gap-12">
            <img
              src="/assets/images/common/logo-mood.svg"
              alt="Mood"
              className="h-6"
            />
            <p className="font-sans text-[10px] tracking-[0.2em] text-gray-400 uppercase">
              © 2026 Mood Agency
            </p>
          </div>
          <div className="flex gap-8">
            <Link to="/" className="font-display text-[10px] tracking-[0.2em] text-gray-400 uppercase hover:text-gray-900 transition-colors">{t('navbar.home')}</Link>
            <Link to="/services" className="font-display text-[10px] tracking-[0.2em] text-gray-400 uppercase hover:text-gray-900 transition-colors">{t('navbar.services')}</Link>
            <Link to="/contact" className="font-display text-[10px] tracking-[0.2em] text-gray-400 uppercase hover:text-gray-900 transition-colors">{t('navbar.contact')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
